import React from "react";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import { Add as AddIcon, Save as SaveIcon, PictureAsPdf as PdfIcon, Visibility as VisibilityIcon, Delete as DeleteIcon } from "@material-ui/icons";
import ReactTable from 'react-table-6';

class ContratEchTable extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            dates: this.props.dates
        }
    }

    componentDidUpdate(prevProps) {
        const { dates } = this.props
        if (dates !== prevProps.dates) {
            this.setState({ dates });
        }
    }
    render() {
        const { disableButton } = this.props
        const { dates } = this.state
        const columns = [
            {
                Header: 'Date',
                accessor: 'dateech',
                width: 200,
                Cell: props => {
                    return <input name={props.column.Header + props.row._index}
                        style={{
                            border: "none", height: "100%", width: "100%", pointerEvents: "visible", backgroundColor: "transparent"
                            , textAlign: "center", fontSize: "14px"
                        }}
                        onChange={(event) => this.props.handleChange(event, props.row._index)}
                        type="date"
                        value={dates[props.row._index] ? dates[props.row._index].dateech : ""}
                        required
                        autoComplete="off" />
                }
            }, {
                Header: 'Désignation',
                accessor: 'raison'
            }
        ]
        const data = dates.map(item => ({
            dateech: item.dateech,
            raison: item.raison
        }));
        return (
            <>
                <div className="echtable">
                    <ReactTable
                        data={data}
                        columns={columns}
                        defaultPageSize={5}
                        pageSizeOptions={[5, 10, 20]}
                        previousText={"Précédent"}
                        nextText={"Suivant"}
                        loadingText={"Chargement en cours..."}
                        noDataText={"Aucune donnée trouvée."}
                        rowsText={"lignes"}
                        ofText={"de"}
                    />
                </div>
                <div className="btn-group">
                    {disableButton && (
                        <CircularProgress className="spinner" color="inherit" />
                    )}
                    <Button className="btn-create" startIcon={<AddIcon />} onClick={this.props.handleValidClick} variant="contained" color="primary" disabled={disableButton} >Nouvel Avenant</Button>
                    <Button onClick={this.props.handleUpdateClick} variant="contained" color="primary" startIcon={<SaveIcon />} disabled={disableButton} >Enregistrer</Button>
                    <Button onClick={this.props.handleGenClick} variant="contained" color="primary" startIcon={<PdfIcon />} disabled={disableButton} >Générer</Button>
                    <Button onClick={this.props.handleShowClick} variant="contained" color="primary" startIcon={<VisibilityIcon />} disabled={disableButton} >Afficher</Button>
                    <Button className="btn-dell" onClick={this.props.handleDellClick} variant="contained" startIcon={<DeleteIcon />} color="primary" disabled={disableButton || this.props.amendment == 1} >Supprimer</Button>
                </div>
            </>
        )
    }
}
export default ContratEchTable;